import { useEnableSampleUploadContent } from "@hireroo/app-helper/feature";
import { App } from "@hireroo/app-store/essential/employee";
import { EmployeeSideBarContent } from "@hireroo/app-store/widget/e/EmployeeSideBarContent";
import { useTranslation } from "@hireroo/i18n";
import type { Pages } from "@hireroo/presentation";
import { generatePath } from "@hireroo/router/api";
import { useTransitionNavigate } from "@hireroo/router/hooks";
import * as React from "react";

import EmployeeHeaderRightContentContainer from "../../../../widget/v2/e/EmployeeHeaderRightContent/Container";
import EmployeeSideBarContentContainer from "../../../../widget/v2/e/EmployeeSideBarContent/Container";
import FooterContainer from "../../../../widget/v2/e/Footer/Container";
import { useNotificationBanner } from "../../../../widget/v2/e/NotificationBanner/Container";
import SnackbarContainer from "../../../../widget/v2/shared/Snackbar/Container";
import HomeContainer from "./widgets/Home/Container";
import SampleUploadContentContainer from "./widgets/SampleUploadContent/Container";

export type GenerateHomePropsArgs = {};

export const useGenerateProps = (_args: GenerateHomePropsArgs): Pages.HomeProps => {
  const { t } = useTranslation();
  const appStatus = App.useStatus();
  const navigate = useTransitionNavigate();
  const NotificationBannerContainer = useNotificationBanner();
  const enableSampleUploadContent = useEnableSampleUploadContent();

  return {
    layout: {
      openSidebar: EmployeeSideBarContent.useOpenSidebar(),
      onChangeOpenSidebar: open => {
        EmployeeSideBarContent.setOpenSidebar(open);
      },
      loading: appStatus === "INITIALIZING",
      NotificationBanner: NotificationBannerContainer,
      HeaderRightContent: <EmployeeHeaderRightContentContainer />,
      SideBarContent: <EmployeeSideBarContentContainer />,
      Footer: <FooterContainer />,
      Snackbar: <SnackbarContainer />,
      sideBarHeader: {
        logo: {
          href: generatePath("/e/home"),
          onClick: () => {
            navigate("/e/home");
          },
        },
      },
      navigationBreadcrumbs: {
        parentLinks: [],
        current: t("ホーム"),
      },
    },
    children: enableSampleUploadContent ? <SampleUploadContentContainer /> : <HomeContainer />,
  };
};
